import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Generic replacement for turbo_stream_from / TurboCableStreamSourceElement.
//
// TurboCableStreamSourceElement has an unreliable subscription lifecycle on
// native (WKWebView) in some cases, causing live broadcasts to be missed.
// This controller uses a direct ActionCable subscription and pipes received
// HTML through Turbo.renderStreamMessage — the same pattern used by
// discovery_controller.js which is known to work reliably on both platforms.
//
// Usage (ERB):
//   <% signed = Turbo::StreamsChannel.signed_stream_name(["my_stream"]) %>
//   <div data-controller="turbo-cable"
//        data-turbo-cable-signed-stream-value="<%= signed %>"></div>
export default class extends Controller {
  static values = { signedStream: String }

  connect() {
    if (!this.signedStreamValue) return

    this._subscription = consumer.subscriptions.create(
      { channel: "Turbo::StreamsChannel", signed_stream_name: this.signedStreamValue },
      { received: (data) => this._received(data) }
    )
  }

  disconnect() {
    this._subscription?.unsubscribe()
  }

  _received(data) {
    if (typeof data === "string" && window.Turbo) {
      window.Turbo.renderStreamMessage(data)
    }
  }
}
